/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable operator-assignment */
/* eslint-disable no-param-reassign */

import {
  MENU, MENU_ITEMS, PLAYERS_ID, SET_POINT_AWAYWIN_GAMESCORES,
  SET_POINT_AWAYWIN_POINTS, SET_POINT_HOMEWIN_GAMESCORES,
  SET_POINT_HOMEWIN_POINTS, SHOW_FILTERS, SUBMENU_ITEMS, TB_SET_POINT_AWAY, TB_SET_POINT_HOME,
} from '../constants';

/**
 * @namespace utils/common
 */
/**
 * Parse date in format DD/MM/YY
 *
 * @memberof utils/common
 * @param {Time} dateString
 * @example 2020-04-27T09:18:02Z
 * parsed to   "27 / 04 / 20"
 * @returns {string} Parsed date and time
 */
export function getDate(dateString) {
  if (dateString) {
    const dateTime = dateString.split('T');
    const date = dateTime[0].split('-');
    return `${date[2]} / ${date[1]} / ${date[0][2]}${date[0][3]}`;
  }
  return '';
}

/**
 * @param {Array} timeHeaders
 * @param {string} timezone
 * @returns {number} updatedTime
 */
export function adjustTimeHeaders(timeHeaders, timezone) {
  const timeUTC = new Date().toLocaleString('en-GB', { timeZone: 'UTC' });
  const timeAtTimezone = new Date().toLocaleString('en-GB', { timeZone: timezone });

  const offset = timeAtTimezone.split(/[/\s:]/)[3] - timeUTC.split(/[/\s:]/)[3];

  return timeHeaders.map((time) => {
    const updatedTime = parseInt(time) + offset;
    if (updatedTime < 24) {
      return updatedTime;
    }
    return updatedTime - 24;
  });
}

/**
 * @param {Date} date
 * @param {string} time
 * @param {string} timezone
 * @param {string} dateString
 * @returns {string}
 * time in format ['hh', 'mm', 'ss]
 * offset is calculated by calculating the difference in hours and adding it to UTC time
 * between time at "Timezone" and UTC time
 * "hour" is at index 3 of the array
 * ['year', 'month', 'date', 'hour', 'min', 'seconds']
 */
function adjustTimeAccordingToTimezone(date, time, timezone, dateString) {
  const specificTimeAtTimezone = new Date(dateString).toLocaleString('en-GB', { timeZone: timezone });

  const detailsArr = specificTimeAtTimezone.split(', ');
  const dateAtTimezone = detailsArr[0];
  const timeAtTimezone = detailsArr[1];
  return `${dateAtTimezone} ${timeAtTimezone}`;
}

/**
 * Parse date in format DD/MM/YYYY, time in format hh:mm:ss
 *
 * @memberof utils/common
 * @param {Time} dateString
 * @param {string} timezone
 * @example 2020-04-27T09:18:02Z
 * parsed to   "27/04/2020 09:18:02"
 * @returns {string} Parsed date and time
 */
export function getDateTime(dateString, timezone) {
  if (dateString) {
    const dateTime = dateString.split('T');
    const date = dateTime[0].split('-');
    const time = dateTime[1].split('.')[0].split(':');
    return adjustTimeAccordingToTimezone(date, time, timezone, dateString);
  }
  return '';
}

/**
 * Parse date in format YYYY/MM/DD
 *
 * @memberof utils/common
 * @param {Time} date
 * @example new Date()
 * parsed to   "17/05/2020"
 * @returns {string}
 */
export function getDateForCalendar(date) {
  if (date) {
    let month = date.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    let day = date.getDate();
    day = day < 10 ? `0${day}` : day;
    return `${day}/${month}/${date.getFullYear()}`;
  }
  return '';
}
/**
 * Parse date in format YYYY-MM-DD
 *
 * @memberof utils/common
 * @param {Time} date
 * @example new Date()
 * parsed to   "2020-05-07"
 * @returns {string}
 */
export function getDateForFilter(date) {
  if (date) {
    let month = date.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    let day = date.getDate();
    day = day < 10 ? `0${day}` : day;
    return `${date.getFullYear()}-${month}-${day}`;
  }
  return '';
}
/**
 * Parse date in format YYYY-MM-DD
 *
 * @memberof utils/common
 * @param {string} date
 * @example "07/05/2020"
 * parsed to   "2020-05-07"
 * @returns {string}
 */
export function getDateFromString(date) {
  if (date) {
    const dates = date.split('/');
    return `${dates[2]}-${dates[1]}-${dates[0]}`;
  }
  return '';
}

/**
 * @param {string} timezone
 * @returns {string} date in format yyyy-mm-dd with respect to timezone selected
 */
export const getTodaysDate = (timezone) => {
  const dateTime = new Date(Date.now()).toLocaleString('en-GB', { timeZone: timezone });
  return getDateFromString(dateTime.split(', ')?.[0]);
};

/**
 * Parse date in format YYYY-MM-DD hh:mm
 *
 * @memberof utils/common
 * @param {Time} date
 * @example new Date()
 * parsed to   "2020-05-07 23:59"
 * @returns {string}
 */
export function getDateForIntervalFilter(date) {
  if (date) {
    let month = date.getMonth() + 1;
    month = month < 10 ? `0${month}` : month;
    let day = date.getDate();
    day = day < 10 ? `0${day}` : day;
    let hour = date.getHours();
    hour = hour < 10 ? `0${hour}` : hour;
    let minute = date.getMinutes();
    minute = minute < 10 ? `0${minute}` : minute;
    return `${date.getFullYear()}-${month}-${day} ${hour}:${minute}`;
  }
  return '';
}

/**
 * take in date in format yyyy-mm-dd and convert it to DATE format
 * e.g Thu Sep 30 2021 15:26:52 GMT+0400 (Mauritius Standard Time)
 *
 * @param {string} date
 * @returns {Date}
 */
export function convertToDATEFormat(date) {
  if (!date) return '';

  const dateArr = date?.split('-');
  if (dateArr?.length !== 3) return '';
  return new Date(dateArr[0], dateArr[1] - 1, dateArr[2]);
}

/**
 * Get day before today
 *
 * @memberof utils/common
 * @returns {Time}
 */
export function getYesterday() {
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  return yesterday;
}

/**
 * @constant
 */
const MONTH_NAMES = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];
/**
 * Get Month in format mm YYYY
 *
 * @memberof utils/common
 * @example new Date()
 * parsed to April 2020
 * @param {Time} date
 * @returns {Time}
 */
export function getMonth(date) {
  return `${MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`;
}
/**
 * Parse amounts
 *
 * @memberof utils/common
 * @param {number} value
 * @param {number} divider
 * @example parseAmount(5000000,1)
 * parsed to   "5,000,000.00"
 * or parseAmount(5000000,100)
 * parsed to   "50,000.00"
 * @returns {string}
 */
export function parseAmount(value, divider) {
  return value
    ? (value / divider).toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    : '0.00';
}
/**
 * Parse points
 *
 * @memberof utils/common
 * @param {number} value
 * @param {char} sign
 * @example parsePoints(5000000,'.')
 * parsed to   "5.000.000"
 * @returns {string}
 */
export function parsePoints(value, sign) {
  return value ? value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${sign}`) : 0;
}
/**
 * Parse float
 *
 * @memberof utils/common
 * @param {number} value
 * @param {number} divider
 * @example parseDecimal(5000000)
 * parsed to   "50000.00"
 * @returns {string}
 */
export function parseDecimal(value, divider) {
  return value ? parseFloat(value / divider).toFixed(2) : '0.00';
}
/**
 * Month here is 1-indexed (January is 1, February is 2, etc). This is
 * because we're using 0 as the day so that it returns the last day
 * of the last month, so you have to add 1 to the month number
 * so it returns the correct amount of days
 *
 * @memberof utils/common
 * @param {number} month
 * @param {number} year
 * @returns {number}
 */
export function daysInMonth(month, year) {
  return new Date(year, month, 0).getDate();
}
/**
 * Return index of day in week
 *
 * @memberof utils/common
 * @param {number} month
 * @param {number} year
 * @returns {number}
 */
export function weekDayInMonth(month, year) {
  return new Date(year, month, 1).getDay();
}

/**
 * Scroll to html element
 *
 * @memberof utils/common
 * @param {string} elementId
 * @returns {void}
 */
export function scrollTo(elementId) {
  const scrollArea = document.getElementsByClassName('content__wrapper')[0];
  const element = document.getElementById(elementId);
  if (scrollArea && element) {
    try {
      scrollArea.scrollTo({
        top: element.getBoundingClientRect().y,
        behavior: 'smooth',
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}

/**
 * @param {string} date
 * @returns {string}
 */
export function parseDate(date) {
  const fullDateArr = date.split('T');
  const dateFormat = fullDateArr[0].split('-').reverse().join('/');
  const timeArr = fullDateArr[1].split('.')[0];
  const timeFormat = timeArr.split(':');

  return `${dateFormat} ${timeFormat[0]}:${timeFormat[1]}`;
}

/**
 * @param {string} event
 * @returns {string}
 */
export function getTimeFromEvent(event) {
  let time = event.split('T')[1].split('.')[0];
  time = time.replace(/:/g, ' : ');
  return time;
}

/**
 * @param {Array} events
 * @returns {Array}
 */
export function getEventTimeHeaders(events) {
  const timeHeaders = [];
  let i = 0;
  events.map((event) => {
    const time = getTimeFromEvent(event.startDateTime);
    const tH = parseInt(time.split(' ')[0]);
    if (tH !== timeHeaders[i - 1]) {
      timeHeaders.push(tH);
      i += 1;
    }
  });
  return timeHeaders;
}

/**
 * @param {string} name
 * @returns {string}
 */
export function getInitials(name) {
  let initials = '';
  const nameArr = name.trim().split(' ');
  if (nameArr.length > 1) {
    initials = `${nameArr[0][0]}${nameArr[1][0]}`;
  } else {
    initials = nameArr[0][0];
  }
  return initials;
}
/**
 * Getting page name and section in sidebar from route pathname
 *
 * @param {string} pathname
 * @returns {object}
 */
export function parseRoute(pathname) {
  const paths = pathname.split('/');
  const path = paths.pop();
  const selectedMenu = paths.length > 2
    ? paths[2]
    : path && path.split('_')[0];
  const selectedSubMenu = paths.length > 3
    ? paths[3].replace('-', '_')
    : '';
  let heading = '';
  Object.keys(MENU).map((k) => {
    if (MENU_ITEMS[k]) {
      Object.keys(MENU_ITEMS[k]).map((kk) => {
        const menuItemsPath = MENU_ITEMS[k][kk].path;
        const checkNestedPath = pathname.indexOf(menuItemsPath) > -1 && MENU_ITEMS[k][kk].nested;
        if (menuItemsPath === pathname || checkNestedPath) {
          heading = MENU_ITEMS[k][kk].titlePage || MENU_ITEMS[k][kk].name;
        }
        if (!heading && SUBMENU_ITEMS[kk]) {
          Object.keys(SUBMENU_ITEMS[kk]).map((subMenuKey) => {
            const subMenuItemsPath = SUBMENU_ITEMS[kk][subMenuKey].path;
            if (subMenuItemsPath === pathname) {
              heading = SUBMENU_ITEMS[kk][subMenuKey].titlePage
                || SUBMENU_ITEMS[kk][subMenuKey].name;
            }
          });
        }
      });
    }
    if (!heading && MENU[k].path === pathname) {
      heading = MENU[k].titlePage || MENU[k].name;
    }
  });

  return {
    selectedMenu, selectedSubMenu, selectedMenuItem: pathname, heading,
  };
}

/**
 * @param {string} dateString (dd/mm/yyyy)
 * @returns {string}
 */
export function parseDateAndMonth(dateString) {
  const details = dateString.split('/');
  return `${details[0]}/${details[1]}`;
}
// /* eslint-disable sonarjs/cognitive-complexity */
export const generateQueryString = (filtersObj) => {
  let params = '?';
  const filterHideEndedMatchesName = 'filterHideEndedMatches';
  if (!filtersObj?.[filterHideEndedMatchesName]) {
    params += `${filterHideEndedMatchesName}=0`;
  } else {
    params += `${filterHideEndedMatchesName}=${filtersObj.filterHideEndedMatches}`;
  }
  const filterKeys = Object.keys(filtersObj);
  for (let i = 0; i < filterKeys.length; i += 1) {
    const hasValue = (filtersObj[filterKeys[i]] || filtersObj[filterKeys[i]] === 0)
      && filtersObj[filterKeys[i]] !== SHOW_FILTERS.ALL && filterKeys[i] !== filterHideEndedMatchesName;
    if (Array.isArray(filtersObj[filterKeys[i]])) {
      for (let j = 0; j < filtersObj[filterKeys[i]].length; j += 1) {
        if (params !== '?') params += '&';
        params += `${filterKeys[i]}=${filtersObj[filterKeys[i]][j]}`;
      }
    } else if (hasValue) {
      if (params !== '?') params += '&';
      params += `${filterKeys[i]}=${filtersObj[filterKeys[i]]}`;
    }
  }

  return params;
};

/**
 * get offset depending on selected timezone
 *
 * @param {string} selectedTimezone
 * @returns {integer} offset
 */
export function getOffsetByTimezone(selectedTimezone) {
  if (!selectedTimezone) return '';

  // 'ja' format is used so that when the sting is split
  // an array with format ['yyyy', 'mm', 'dd, 'hh', 'mm', 'ss'] is obtained
  const dateTimeDetailsArr = new Date().toLocaleString('ja', { timeZone: selectedTimezone }).split(/[/\s:]/);

  // remove 1 from month field because month in
  // zero based format is required for further manipulations
  dateTimeDetailsArr[1] -= 1;

  const t1 = Date.UTC.apply(null, dateTimeDetailsArr);
  const t2 = new Date().setMilliseconds(0);
  return (t1 - t2) / 60 / 1000;
}

/**
 * convert date to UTC date with respect to timezone
 *
 * @param {string} selectedTimezone
 * @param {Time} date
 * @returns {string} Parsed date and time
 */
export function adjustAccordingToTimezone(selectedTimezone, date) {
  const currentDate = date ? new Date(date) : new Date();

  const adjustedDate = new Date(Date.UTC(currentDate.getUTCFullYear(),
    currentDate.getUTCMonth(), currentDate.getUTCDate(),
    currentDate.getUTCHours(),
    currentDate.getUTCMinutes() - getOffsetByTimezone(selectedTimezone),
    currentDate.getUTCSeconds()));

  const formattedDateTimeString = getDateForIntervalFilter(adjustedDate);
  return formattedDateTimeString.replace(' ', 'T');
}

/**
 * convert decimal to percentage
 *
 * @param {number} decimal
 * @returns {string} percentage
 */
export const formatProbability = (decimal) => {
  if (!decimal) return '';
  return (decimal * 100);
};

/**
 * extract date in format dd/mm from dateString in format "dd/mm/yyyy hh:mm:ss"
 *
 * @param {string} dateString
 * @returns {string} date in format dd/mm
 */
export const extractDate = (dateString) => {
  if (!dateString) return '';

  const fullDate = dateString.split(' ')[0];
  const dateArr = fullDate?.split('/');

  return `${dateArr[0]}/${dateArr[1]}`;
};
/**
 * remove duplicates element in an array
 *
 *@param {Array} array
 * @returns {Array}
 */
export const removeDuplicatesInArray = (array) => {
  if (!Array.isArray(array)) return [];

  const result = [];
  array.forEach((element) => {
    if (!result.includes(element)) {
      result.push(element);
    }
  });
  return result;
};

export const isSameValue = (value1, value2, type) => {
  switch (type) {
    case 'text':
      return String(value1).trim() === String(value2).trim();
    case 'number':
      return Number(value1) === Number(value2);
    default:
      return value1 === value2;
  }
};

/*
* determines if breakPoint occurs for the current pointScore
* breakPoint scenario: player who is about to win point is not the serving player
*/
export const checkBreakPoint = (pointScore, servingPlayer) => {
  if (!pointScore || !servingPlayer) return false;

  const [player1Score, player2Score] = pointScore.split(':');

  if (servingPlayer === PLAYERS_ID.PLAYER_1
    && ((player2Score === '40' && Number(player2Score) > Number(player1Score))
      || (player2Score === 'A'))
  ) {
    return true;
  }
  if (servingPlayer === PLAYERS_ID.PLAYER_2
    && ((player1Score === '40' && Number(player1Score) > Number(player2Score))
      || (player1Score === 'A'))
  ) {
    return true;
  }
  return false;
};

/**
 * generate list of set point
 *
 * @returns {object}
 */
function generateSetPointMap() {
  const map = {};
  SET_POINT_HOMEWIN_POINTS.forEach((point) => {
    map[point] = SET_POINT_HOMEWIN_GAMESCORES;
  });

  SET_POINT_AWAYWIN_POINTS.forEach((point) => {
    map[point] = SET_POINT_AWAYWIN_GAMESCORES;
  });
  return map;
}

/*
* determines if setPoint occurs for the current pointScore
*/
export const checkSetPoint = (pointScore, setHistory) => {
  if (!pointScore || !setHistory) return false;

  const {
    playerOneGamesScore,
    playerTwoGamesScore,
  } = setHistory;

  const currentScore = `${playerOneGamesScore}:${playerTwoGamesScore}`;
  const SET_POINT_MAP = generateSetPointMap();
  if (SET_POINT_MAP[pointScore]?.includes(currentScore)) return true;

  return false;
};

export const checkTBSetPoint = (p1TBScore, p2TBScore) => {
  const pointScore = `${p1TBScore}:${p2TBScore}`;

  if (TB_SET_POINT_HOME?.includes(pointScore)) {
    return PLAYERS_ID.PLAYER_1;
  }

  if (TB_SET_POINT_AWAY?.includes(pointScore)) {
    return PLAYERS_ID.PLAYER_2;
  }

  if (p1TBScore > 6 && p1TBScore - p2TBScore === 1) {
    return PLAYERS_ID.PLAYER_1;
  }

  if (p2TBScore > 6 && p2TBScore - p1TBScore === 1) {
    return PLAYERS_ID.PLAYER_2;
  }

  return null;
};

/**
 * Given an array of tuples,
 * return concatinated query params string
 *
 * @param {Tuples[]} params - query params to build
 * @example
 * [
 *  ['userId', 1],
 *  ['start', '2023-09-01']
 * ]
 * @returns {string} query params string ex. ?userId=1&start=2023-09-01
 */
export function buildQueryParams(params) {
  const queryParams = [];

  params.forEach((param) => {
    const [key, value] = param;

    if (value !== '' && value !== null && value !== undefined) {
      queryParams.push(`${key}=${value}`);
    }
  });

  const query = queryParams.join('&');
  return `?${query}`;
}

/**
 * Given a string of query params,
 * return query params as an array of tuples
 *
 * @param {string} queryParams - query params to build
 * @example
 * ?userId=1&start=2023-09-01
 * @returns {Tuples[]} query params tuples[]
 * ex. [
 *  ['userId', 1],
 *  ['start', '2023-09-01'],
 * ]
 */
export function extractQueryParamsToArray(queryParams) {
  // eslint-disable-next-line no-unused-vars
  const [questionMark, paramsString] = queryParams.split('?');
  const keyPairValues = paramsString.split('&');

  return keyPairValues.map((pair) => pair.split('='));
}
/**
 * Given allMarkets arrays that have id , name etc...
 * MarketsData is the selected market which have only id_market ,
 * return an array of selected market that have id and name
 *
 * @param {Array} allMarkets
 * @param {Array} marketsData
 * @returns {Array}
 */
export const addMarketsName = (allMarkets, marketsData) => {
  if (!marketsData || !allMarkets
    || allMarkets.length === 0
    || marketsData.length === 0) return null;
  const marketsFiltered = [];
  marketsData.forEach(
    (selectedMarket) => {
      const marketData = allMarkets.find(
        (market) => market.id === selectedMarket.market_id,
      );
      if (marketData) {
        marketsFiltered.push({
          id: marketData.id,
          name: marketData.name,
        });
      }
    },
  );
  return marketsFiltered;
};
